export class PlanGoodsNutritionUnitModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 分析連番
  public analysisSeqNo: string = <string>'';

  // 分析単位
  public analysisUnit: string = <string>'';

  // 栄養成分備考
  public nutritionalNote: string = <string>'';

  // メンテナンス種別(分析単位用)
  public maintenanceDivUnit: string = <string>'';

  // メンテナンス種別(栄養成分備考用)
  public maintenanceDivNote: string = <string>'';

  // 画面表示用データ項目名
  public itemNameForForm: string = <string>'';

  // 栄養成分詳細VOリスト
  public planGoodsNutritionDetailVOList: any = new Array<any>();

}
